import { z } from "zod";

export const unmergeFulfillmentGroups = {
  input: z.object({ fulfillmentGroupIds: z.array(z.string()) }),
  output: z.object({}),
};
